var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.broadcast)?_c('div',{staticClass:"broadcast-section"},[(_vm.broadcast)?_c('WizardForm',{attrs:{"broadcast":_vm.broadcast},on:{"broadcast-changed":_vm.broadcastChanged}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }